var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-1{stroke:#b9c1c6;}.cls-2{stroke:#a5a9aa;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.5,
    x2: 29.5,
    y1: 17.5,
    y2: 17.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.5,
    x2: 22.5,
    y1: 22.5,
    y2: 22.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.5,
    x2: 55.5,
    y1: 27.5,
    y2: 27.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.5,
    x2: 57.5,
    y1: 32.5,
    y2: 32.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.5,
    x2: 31.5,
    y1: 32.5,
    y2: 32.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.5,
    x2: 56.5,
    y1: 37.5,
    y2: 37.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.5,
    x2: 52.5,
    y1: 42.5,
    y2: 42.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.5,
    x2: 42.5,
    y1: 47.5,
    y2: 47.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.5,
    x2: 23.5,
    y1: 37.5,
    y2: 37.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.5,
    x2: 35.5,
    y1: 22.5,
    y2: 22.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 45.5,
    x2: 52.5,
    y1: 22.5,
    y2: 22.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.a99a8b2aec6ef0e56f2397ca4a10a90c.svg";
export { ForwardRef as ReactComponent };